import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setObjectToState } from './helper';
/*eslint no-case-declarations: 0 */

const initialState = defaultState.geoJsonData;

export default (state = initialState, action) => {
  switch(action.type) {
    case ActionTypes.SET_GEOJSON:
      const {parkingLocations, parkingSpots, pointsOfInterest} = action;
      return setObjectToState(state, {
        parkingLocations,
        parkingSpots,
        pointsOfInterest,
      });
      
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/geoJsonDataReducer.js